import "./DianShang.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _component = require("../_utils/component");

var _QuickItem = _interopRequireDefault(require("./QuickItem"));

var _vueNormalizeComponent = _interopRequireDefault(require("../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var __vue_script__ = {
  name: (0, _component.createComponentName)('quick-link-dianshang'),
  components: {
    QuickItem: _QuickItem.default
  },
  mixins: [_component.componentMixin]
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("quick-item", {
    class: _vm.bem()
  }, [_c("div", [_c("i", {
    class: _vm.bem("icon")
  }), _vm._v(" "), _c("span", [_vm._v("粉丝群")])]), _vm._v(" "), _c("div", {
    class: _vm.bem("tip"),
    attrs: {
      slot: "tip"
    },
    slot: "tip"
  }, [_c("div", [_c("img", {
    attrs: {
      src: require("../../assets/img/dianshang-qq.png"),
      alt: "稿定粉丝qq群"
    }
  }), _vm._v(" "), _c("span", [_vm._v("电商QQ交流群")])]), _vm._v(" "), _c("div", [_c("img", {
    attrs: {
      src: require("../../assets/img/dianshang-wechat.png"),
      alt: "稿定粉丝微信群"
    }
  }), _vm._v(" "), _c("span", [_vm._v("电商微信交流群")])])])]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default;